import { StaticBaseDao } from '@/dao';
import {
    AddTimeRequest,
    IntArray,
    DisableTimeRequest,
    EnableTimeRequest,
    TimepenaltyRequest,
    AddShootingRequest,
    SwapTimesBetweenContestantsRequest,
    GetRaceContestantTimesRequest,
    RaceContestantTime,
    GetContestantTimesRequest,
    ContestantTime,
} from '@/objects/generated';
import { formatDateIso } from '@/utilities/dateutils';

export class TimeDao extends StaticBaseDao {
    public static async AddTimes(eventID: number, requests: AddTimeRequest[]): Promise<IntArray | null> {
        return this.BaseFetch(IntArray, `Time/AddTimes` + '?' + (eventID == undefined ? '' : `eventID=${eventID}`), 'POST', requests);
    }
    public static async AddTIM(eventID: number, requests: AddTimeRequest[]): Promise<IntArray | null> {
        return this.BaseFetch(IntArray, `Time/AddTIM` + '?' + (eventID == undefined ? '' : `eventID=${eventID}`), 'POST', requests);
    }
    public static async AddTime(EventID: number, Bib: number, StationID: number, Time: Date): Promise<IntArray | null> {
        return this.BaseFetch(
            IntArray,
            `Time/AddTime` +
                '?' +
                (EventID == undefined ? '' : `EventID=${EventID}`) +
                '&' +
                (Bib == undefined ? '' : `Bib=${Bib}`) +
                '&' +
                (StationID == undefined ? '' : `StationID=${StationID}`) +
                '&' +
                (Time == undefined ? '' : `Time=${formatDateIso(Time)}`),
            'GET',
        );
    }
    public static async DisableTimes(eventID: number, requests: DisableTimeRequest[]): Promise<boolean | null> {
        return this.Post(`Time/DisableTimes` + '?' + (eventID == undefined ? '' : `eventID=${eventID}`), requests);
    }
    public static async EnableTimes(eventID: number, requests: EnableTimeRequest[]): Promise<boolean | null> {
        return this.Post(`Time/EnableTimes` + '?' + (eventID == undefined ? '' : `eventID=${eventID}`), requests);
    }
    public static async AddPenalty(request: TimepenaltyRequest): Promise<TimepenaltyRequest | null> {
        return this.BaseFetch(TimepenaltyRequest, `Time/AddPenalty`, 'POST', request);
    }
    public static async AddShooting(eventID: number, requests: AddShootingRequest[]): Promise<IntArray | null> {
        return this.BaseFetch(IntArray, `Time/AddShooting` + '?' + (eventID == undefined ? '' : `eventID=${eventID}`), 'POST', requests);
    }
    public static async SwapTimeBetweenContestants(EventID: number, request: SwapTimesBetweenContestantsRequest): Promise<boolean | null> {
        return this.Post(`Time/SwapTimeBetweenContestants` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`), request);
    }
    public static async GetRaceContestantTimes(
        eventID: number,
        getRankedTimesRequest?: GetRaceContestantTimesRequest,
    ): Promise<RaceContestantTime[]> {
        return this.BaseFetchArray(
            RaceContestantTime,
            `Time/GetRaceContestantTimes` + '?' + (eventID == undefined ? '' : `eventID=${eventID}`),
            'POST',
            getRankedTimesRequest,
        );
    }
    public static async GetContestantTimes(
        eventID: number,
        getContestantTimesRequest?: GetContestantTimesRequest,
    ): Promise<ContestantTime[]> {
        return this.BaseFetchArray(
            ContestantTime,
            `Time/GetContestantTimes` + '?' + (eventID == undefined ? '' : `eventID=${eventID}`),
            'POST',
            getContestantTimesRequest,
        );
    }
}
